import { useSportUpcomingEvents } from '../../hooks/SportUpcomingEventsProvider/SportUpcomingEventsProvider';

import { SportUpcomingEvent } from './SportUpcomingEvent';
import { SportUpcomingEventsLabel } from './SportUpcomingEventLabel';
import { SportUpcomingEventsSkeleton } from './SportUpcomingEventsSkeleton';

export const SportUpcomingEvents = () => {
  const sportUpcomingEvents = useSportUpcomingEvents();
  const shouldNotRenderSportUpcomingEvents =
    !sportUpcomingEvents.enabled || sportUpcomingEvents.state === 'error';

  if (shouldNotRenderSportUpcomingEvents) {
    return null;
  }

  return (
    <div className="vgp-sport-upcoming-events-container">
      <SportUpcomingEventsLabel />
      <div className="vgp-sport-upcoming-events">
        {sportUpcomingEvents.state === 'loading' ? (
          <SportUpcomingEventsSkeleton />
        ) : (
          sportUpcomingEvents.events.map((event) => (
            <SportUpcomingEvent event={event} />
          ))
        )}
      </div>
    </div>
  );
};
